import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { TextProvider } from "./components/TextProvider";
import { BrowserRouter as Router } from 'react-router-dom';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <TextProvider>
        <App />
      </TextProvider>
    </Router>
  </React.StrictMode>
);

